/**
 * The single semester a scholarship covers when a full-year award has been converted to a single
 * term. Null means the standard full-year award.
 * String values match the API C# enum member names, since the API serializes enums as
 * strings (JsonStringEnumConverter) — keeping the dropdown value in sync with the wire format.
 */
export enum SingleTermAward {
  Fall = 'Fall',
  Spring = 'Spring'
}
